export type EtikettenartUsage = 'Eigenware' | 'Fremdmarke' | 'ohne Artikelbezug';
export type EtikettenartSource = 'OwnBrand' | 'ArticleLabel' | 'NonProduct';

export interface IEtikettenart {
  key: string;
  name: string;
  usage: EtikettenartUsage;
  source: EtikettenartSource;
  family: string;
  numericValue?: string;
  widthMm?: number;
  heightMm?: number;
}

export const ETIKETTENARTEN: IEtikettenart[] = [
  { key: 'XLLabel', name: 'Große Dose', usage: 'Eigenware', source: 'OwnBrand', family: 'F1', numericValue: '0', widthMm: 195, heightMm: 70 },
  { key: 'SmallLabel', name: 'Kleine Dose', usage: 'Eigenware', source: 'OwnBrand', family: 'F3', numericValue: '1', widthMm: 195, heightMm: 25 },
  { key: 'XLVerticalLabel', name: 'Nachfüllpackung', usage: 'Eigenware', source: 'OwnBrand', family: 'F2', numericValue: '2', widthMm: 70, heightMm: 195 },
  { key: 'XSLabel', name: 'XS Etikett', usage: 'Eigenware', source: 'OwnBrand', family: 'F4', numericValue: '3', widthMm: 100, heightMm: 27 },
  { key: 'SpreaderLabel', name: 'Streuer-Etikett', usage: 'Eigenware', source: 'OwnBrand', family: 'F1', numericValue: '4', widthMm: 195, heightMm: 70 },
  { key: 'GrinderLabel', name: 'Mühlen-Etikett', usage: 'Eigenware', source: 'OwnBrand', family: 'F3', numericValue: '5', widthMm: 195, heightMm: 25 },
  { key: 'XLLabelBig', name: 'XL Dose', usage: 'Eigenware', source: 'OwnBrand', family: 'F1', numericValue: '6', widthMm: 195, heightMm: 70 },
  { key: 'XLVerticalLabelBig', name: 'XL Nachfüllpackung', usage: 'Eigenware', source: 'OwnBrand', family: 'F2', numericValue: '7', widthMm: 70, heightMm: 195 },
  { key: 'GlassVialLabel', name: 'Glasfläschchen', usage: 'Eigenware', source: 'OwnBrand', family: 'F3', numericValue: '8', widthMm: 195, heightMm: 25 },
  { key: 'SmallRound', name: 'rund 45x45', usage: 'Eigenware', source: 'OwnBrand', family: 'F6', numericValue: '9', widthMm: 45, heightMm: 45 },
  { key: 'XSNewLabel', name: 'XS Neues Etikett', usage: 'Eigenware', source: 'OwnBrand', family: 'F5', numericValue: '10', widthMm: 68, heightMm: 45 },
  { key: 'XSNewLabelWithEan', name: 'XS Neues Etikett mit EAN', usage: 'Eigenware', source: 'OwnBrand', family: 'F5', numericValue: '11', widthMm: 68, heightMm: 45 },
  { key: 'XLLabelBigNew', name: 'XL-dose NEU', usage: 'Eigenware', source: 'OwnBrand', family: 'F1-new', numericValue: '12', widthMm: 240, heightMm: 90 },
  { key: 'RoundWithProductName', name: 'Rund mit Produktname', usage: 'Fremdmarke', source: 'ArticleLabel', family: 'F12', widthMm: 58, heightMm: 58 },
  { key: 'EAN', name: 'EAN', usage: 'Fremdmarke', source: 'ArticleLabel', family: 'F8', widthMm: 50, heightMm: 15 },
  { key: 'Round58x58', name: '58x58 mm', usage: 'Fremdmarke', source: 'ArticleLabel', family: 'F11', widthMm: 58, heightMm: 58 },
  { key: 'Round50x25', name: '50x25 mm', usage: 'Fremdmarke', source: 'ArticleLabel', family: 'F9', widthMm: 50, heightMm: 25 },
  { key: 'Round50x50', name: '50x50 mm', usage: 'Fremdmarke', source: 'ArticleLabel', family: 'F10', widthMm: 50, heightMm: 50 },
  { key: 'FremdmarkeNutrition', name: 'Fremdmarke mit Nährwerten', usage: 'Fremdmarke', source: 'ArticleLabel', family: 'F14', widthMm: 195, heightMm: 25 },
  { key: 'WhoPacked', name: 'Logistikteam Namens-Etiketten', usage: 'ohne Artikelbezug', source: 'NonProduct', family: 'F12', widthMm: 58, heightMm: 58 },
  { key: 'OutletStore', name: 'Outlet-Store-Etiketten', usage: 'ohne Artikelbezug', source: 'NonProduct', family: 'F13', widthMm: 210, heightMm: 297 },
];

export const STATUS_ANGELEGT = 'angelegt' as const;
export const STATUS_FEHLT = 'fehlt' as const;
export const STATUS_ETIKETTENART_NICHT_GEPFLEGT = 'Etikettenart nicht gepflegt' as const;

export const VERWENDUNG_OPTIONS = [
  { value: 'Eigenware', label: 'Eigenware' },
  { value: 'Fremdmarke', label: 'Fremdmarke' },
  { value: 'Geschenkset', label: 'Geschenkset' },
];

export const ARTICLE_ETIKETTENARTEN = ETIKETTENARTEN.filter(x => x.source !== 'NonProduct');

export function getEtikettenartByKey(key: string): IEtikettenart | undefined {
  return ETIKETTENARTEN.find(x => x.key === key);
}

export function getEtikettenartByNumericValue(value: string | null | undefined): IEtikettenart | undefined {
  if (value == null || value === '') {
    return undefined;
  }
  return ETIKETTENARTEN.find(x => x.numericValue === String(value));
}
